import { ReactNode, useState } from 'react';
import React from 'react';

import PurchaseOptionsDrawer from './components/PurchaseOptionsDrawer';
import {
  PurchaseOptionsDrawerProduct,
  PurchaseOptionsOverlayContext,
} from './PurchaseOptionsDrawerProvider.context';

export type PurchaseOptionsDrawerProviderProps = {
  children: ReactNode;
};

// Create a provider component to wrap your app
const PurchaseOptionsDrawerProvider: React.FC<
  PurchaseOptionsDrawerProviderProps
> = ({ children }) => {
  // Set the initial product data
  const [products, setProduct] = useState<PurchaseOptionsDrawerProduct | null>(
    null,
  );

  const value = {
    product: products,
    setProduct: (product: PurchaseOptionsDrawerProduct) => setProduct(product),
    clearProduct: () => setProduct(null),
  };

  return (
    <PurchaseOptionsOverlayContext.Provider value={value}>
      {children}
      <PurchaseOptionsDrawer />
    </PurchaseOptionsOverlayContext.Provider>
  );
};

export default PurchaseOptionsDrawerProvider;
